import { render, staticRenderFns } from "./WebsiteMessagesList.vue?vue&type=template&id=047bf3e0&scoped=true"
import script from "./WebsiteMessagesList.vue?vue&type=script&lang=js"
export * from "./WebsiteMessagesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047bf3e0",
  null
  
)

export default component.exports